import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '@ng-falcon/icons/icons.module';
import { NgfTooltipDirective } from '@ng-falcon/ngf-tooltip/ngf-tooltip.directive';
import { DialogModule } from '@ng-falcon/dialog/dialog.module';
import { NgfButtonDirective } from '@ng-falcon/button/ngf-button/ngf-button.directive';
import { TextEditorTemplateSelectorComponent } from './text-editor-template-selector/text-editor-template-selector.component';
import { TextEditorTemplateSelectDialogComponent } from './+dialog/text-editor-template-select-dialog.component';
import { SelectModule } from '@ng-falcon/controls/select/select.module';
import { NgfFormModule } from '@ng-falcon/ngf-form/ngf-form.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@ng-falcon/controls/checkbox/checkbox.module';



@NgModule({
  declarations: [
    TextEditorTemplateSelectorComponent,
    TextEditorTemplateSelectDialogComponent
  ],
  imports: [
    CommonModule,
    NgfButtonDirective,
    IconsModule,
    NgfTooltipDirective,
    DialogModule,
    SelectModule,
    CheckboxModule,
    NgfFormModule,
    ReactiveFormsModule
  ],
  exports: [
    TextEditorTemplateSelectorComponent
  ]
})
export class TextEditorTemplatesModule { }
